var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "rankTitle", staticClass: "flex yxtbiz-rank__rank-title ml8 mr8" },
    [
      _vm._t("title"),
      !_vm.styleObject.hideTitle
        ? _c(
            "div",
            { staticClass: "flex-1 yxtbiz-rank__rank-title-default-title" },
            [
              _c(
                "div",
                { staticClass: "flex align-items-center" },
                [
                  _c(
                    "yxtf-tooltip",
                    {
                      staticClass: "ellipsis",
                      attrs: {
                        placement: "top",
                        "open-filter": "",
                        content: _vm.titleObj.title,
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-26 standard-size-16 yxtf-weight-6",
                        },
                        [_vm._v(_vm._s(_vm.titleObj.title))]
                      ),
                    ]
                  ),
                  _vm.titleObj.type === 2
                    ? _c(
                        "yxtf-tag",
                        { staticClass: "ml8", attrs: { size: "mini" } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("pc_biz_rank_group_rank").d("集团榜"))
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("select-conditions", {
        staticClass: "ml24",
        on: {
          changeDate: function ($event) {
            return _vm.$emit("changeDate", $event)
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }